import { TrashIcon } from "@heroicons/react/24/outline";
import { GroupRow } from "../../api/group.type";
import { SubmitButton } from "../shared/buttons/submit-button";
import Card from "../shared/card";
import Typography from "../shared/typography";

export default function GroupsList({
  groups,
  remove,
}: {
  groups: GroupRow[];
  remove: (groupId: string) => Promise<void>;
}) {
  return (
    <div className="grid gap-2 mb-8">
      {groups.map((group) => (
        <Card key={group.id} variant="default" elevation={1}>
          <Card.Body className="relative grid grid-cols-2 gap-2 p-4 m-2">
            <Typography variant="subtitle1">{group.name}</Typography>
            <Typography variant="body2">
              {group.user_group?.length} member
              {group.user_group?.length === 1 ? "" : "s"}
            </Typography>
            <SubmitButton
              className="absolute top-1 right-1"
              size="sm"
              color="cream"
              icon={<TrashIcon className="w-4 h-4" />}
              onClick={() => remove(group.id)}
              iconOnly
            />
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}
